import pulse from "@finn-no/pulse-sdk";

export function trackPageView(): void {
  pulse.trackPageView({
    type: "View",
    object: {
      type: "Page",
      pageType: "landingpage",
    },
    vertical: {
      name: "effect_documentation",
      subVertical: "realestate",
    },
  });
}
